// /*--------------------------------------------------------------
//  * Copyright (c) Microsoft Corporation. All rights reserved.
//  * See License.txt in the project root for license information.
//  *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutCustomerAccountPaymentViewProps } from './lds-checkout-customer-account-payment';
import { IAccountPaymentEditViewForm, IGetAccountPaymentEditViewFormInput } from './components/get-account-payment-form-edit-mode';
import { IAccountPaymentSummaryViewForm } from './components/get-account-payment-form-summary-mode';
//@ts-ignore
import { Primary } from '@churchofjesuschrist/eden-buttons';
import styled from 'styled-components';

export const SummaryForm: React.FC<IAccountPaymentSummaryViewForm> = ({
    formProps,
    label,
    paymentAmount,
    addPaymentButton,
    appliedLine,
    bottomBorder
}) => {
    return (
        <Node {...formProps}>
            <>
                {label}
                {paymentAmount}
                {addPaymentButton}
                {appliedLine}
                {bottomBorder}
            </>
        </Node>
    );
};

export interface EditFormProps {
    accountForm: IAccountPaymentEditViewForm;
    submitProps?: IGetAccountPaymentEditViewFormInput;
}
interface IEditFormExtended extends IAccountPaymentEditViewForm {
    paymentLabel?: string;
}

export const EditForm: React.FC<IEditFormExtended> = ({
    formProps,
    addPaymentButton,
    alert,
    accountDetails,
    appliedLine,
    bottomBorder,
    paymentLabel
}) => {
    const PaymentButtonLabel = styled.div`
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        margin-top: 15px;
    `;

    return (
        <Node {...formProps}>
            <>
                <div>
                    <PaymentButtonLabel>
                        {alert}
                        {/*@ts-ignore */}
                        <Primary {...addPaymentButton.props}>{paymentLabel}</Primary>
                    </PaymentButtonLabel>
                    {appliedLine}
                </div>
                {accountDetails}
                {bottomBorder}
            </>
        </Node>
    );
};

const CheckoutCustomerAccountView: React.FC<ICheckoutCustomerAccountPaymentViewProps> = props => {
    const { checkoutCustomerAccount, summaryView, editView, moduleState } = props;
    //@ts-ignore
    const paymentLabel = props.resources.applyPaymentLabel;
    return (
        <Module {...checkoutCustomerAccount}>
            {moduleState.isReady && summaryView && <SummaryForm {...summaryView} />}
            {!moduleState.isReady && editView && <EditForm {...editView} paymentLabel={paymentLabel} />}
        </Module>
    );
};

export default CheckoutCustomerAccountView;
